import React from 'react';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { useNavigate } from 'react-router';
import './style.css';
import { getIconStatus } from 'src/app/utils/vehicleService';
import { showLoading } from 'src/features/videoSlice';
import { useDispatch } from 'react-redux';

const VehicleTableCell = props => {
  const { row, index } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMoving = row.device_status === 'moving' ? true : false;
  const icon = row.debt === true 
    ? '/static/iconSvg/motors/motor_expired.svg' 
    : getIconStatus(row.device_status, row.vehicle_type);
  const iconCameraLive =
    isMoving
      ? `/static/iconSvg/video_motion_active.svg`
      : `/static/iconSvg/video_motion.svg`;

  return (
    <>
      <Box
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '3px',
          paddingLeft:"3px"
        }}
      >
        <Box style={{ width: '27px', height: '27px' }}>
          <img alt="car" src={icon} style={{ width: '100%', height: '100%' }} />
        </Box>
        <Typography style={{ 
           fontSize: '12px',
           fontWeight: 'bold',
           whiteSpace: 'nowrap', 
           overflow: 'hidden', 
           textOverflow: 'ellipsis', 
           maxWidth: '80px' 
        }}>
          {row?.license_plate}
        </Typography>
      </Box>

      {row?.device_type === 'VGPS_CAM4G' && (
        <Box
          key={index}
          style={{ width: '14px', height: '8.94', objectFit:'cover' }}
          onClick={e => {
            e.stopPropagation();
            dispatch(showLoading({ device_serial: row.device_serial }));
            navigate(
              `/app/camera/streaming?&show_menu=true`
            );
          }}
        >
          <img
            alt="car"
            src={iconCameraLive}
            style={{ width: '100%', height: '100%', objectFit:'cover' }}
          />
        </Box>
      )}
    </>
  );
};

export default React.memo(VehicleTableCell);
